<h2>Exclusive content</h2>
<h5>Some of our content is only available to EBU Members</h5>
<br />
<div>
  Unfortunately, you do not have the rights to access this content.
  <br /><br />
  Many of our publications are publicly available, but some are restricted to users belonging to EBU Members, group or event participants.
  <br />
  If you belong to an EBU Member, Associate or Approved Participant please make sure that your work email address with the organization's domain name is associated with your account.
  <br /><br />
  If you think this is an error, please send an email to <a href="mailto:collaboration@ebu.ch?subject=I%20should%20get%20acces%20to&amp;body=page%20url%20%3A%20%0Auser%20name%20%3A%0A" title="email admin">collaboration@ebu.ch</a> with:
  <ul>
    <li>your username, and</li>
    <li>the url of the content you are trying to access</li>
  </ul>

</div>



// WEBPACK FOOTER //
// ./src/app/auth/not-authorized/not-authorized.component.html